import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { UtilService } from 'src/app/services/util.service';
import { AuthService } from '../auth/auth.service';
import { Observable, Subject, of } from 'rxjs';
import { catchError, take } from 'rxjs/operators';

const BackendUrl = environment.BackendUrl;

@Injectable({
  providedIn: 'root'
})

export class CatalogueService {

  getCatalogueDataUpdated = new Subject<any>();
  getSingleCatalogueDataUpdated = new Subject<any>();
  getCatalogueDepartmentsUpdated = new Subject<any>();
  /** Header catalogue badge. Emitted after a catalogue product is added or removed. */
  catalogueListChanged = new Subject<void>();

  constructor(private http: HttpClient, private utilService: UtilService, private authService: AuthService) { }

  notifyCatalogueListChanged(): void {
    this.catalogueListChanged.next();
  }

  /** One response per caller. Do not share getCatalogueDataUpdated across list, count, and department lookups. */
  private catalogueList$(url: string): Observable<any> {
    const token = localStorage.getItem('token');
    const headers = new HttpHeaders({ Accept: 'application/json', Authorization: token });
    return this.http.get(url, { headers }).pipe(
      take(1),
      catchError((error) => {
        if (error?.status === 401) {
          this.authService.logout();
        }
        return of(null);
      })
    );
  }

  AllWithSuborganisations$(orgId): Observable<any> {
    return this.catalogueList$(BackendUrl + '/organisations_k_products/' + orgId + '/sub/');
  }

  AllMoreInformation$(orgId): Observable<any> {
    return this.catalogueList$(BackendUrl + '/organisations_k_products/' + orgId);
  }

  AllWithSuborganisations(orgId) {
    let token = localStorage.getItem('token');
    const headers = new HttpHeaders({'Accept':'application/json','Authorization':token});
    this.http.get(BackendUrl + '/organisations_k_products/' + orgId + '/sub/',{headers: headers}).pipe(take(1)).subscribe({next: response => {
        this.getCatalogueDataUpdated.next(response);
      },
      error: error => {
        if (error.status === 401)
        {
          this.authService.logout();
        }
        this.getCatalogueDataUpdated.next(null);
      }
    });
  }
// Get all products with extra information

AllMoreInformation(orgId) {
    let token = localStorage.getItem('token');
    const headers = new HttpHeaders({'Accept':'application/json','Authorization':token});
    this.http.get(BackendUrl + '/organisations_k_products/' + orgId,{headers: headers}).pipe(take(1)).subscribe({next: response => {
        this.getCatalogueDataUpdated.next(response);
      },
      error: error => {
        if (error.status === 401)
        {
          this.authService.logout();
        }
        this.getCatalogueDataUpdated.next(null);
      }
    });
  }

  getSingle(prodId) {
    var orgId = JSON.parse(localStorage.getItem("catalogueDepartment"));
    let token = localStorage.getItem('token');
    const headers = new HttpHeaders({'Accept':'application/json','Authorization':token});
    this.http.get(BackendUrl + "/organisations_k_products/" + orgId+"/"+prodId,{headers: headers})
      .pipe(take(1)).subscribe({next: (response) => {
        this.getSingleCatalogueDataUpdated.next(response);
      },
      error: error => {
        if (error.status === 401)
        {
          this.authService.logout();
        }
        this.getSingleCatalogueDataUpdated.next(null);
      }
    });
  }

  getDepartmentsWhereProductAppearsByCatalogueId(productId) {
    var departmentId = JSON.parse(localStorage.getItem("selectedOrganisation")).main_organisation;
    let token = localStorage.getItem('token');
    const headers = new HttpHeaders({'Accept':'application/json','Authorization':token});
    this.http.get(BackendUrl + "/organisations_k_products/" + departmentId + "/" + productId + "/suborgs",{headers: headers})
      .pipe(take(1)).subscribe({next: (response) => {
        this.getCatalogueDepartmentsUpdated.next(response);
      },
      error: error => {
        if (error.status === 401)
        {
          this.authService.logout();
        }
        this.getCatalogueDepartmentsUpdated.next(null);
      }
    });
  }

  public getCatalogueDataListener() {
    return this.getCatalogueDataUpdated.asObservable();
  }

  public getCatalogueDepartmentsListener() {
    return this.getCatalogueDepartmentsUpdated.asObservable();
  }

  public getSingleCatalogueDataListener() {
    return this.getSingleCatalogueDataUpdated.asObservable();
  }
}


